export default "__VITE_ASSET__93841af8__"